import { render, staticRenderFns } from "./BizInsuranceDataList.vue?vue&type=template&id=ab41fef0&"
import script from "./BizInsuranceDataList.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceDataList.vue?vue&type=script&lang=js&"
import style0 from "./BizInsuranceDataList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports